import axios from "../axios";

const getPayOuts = async function (accessToken,params = {}) {
    try {
        const response = await axios.post('pay-out/getPayOuts', params,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getPayOuts;
